import React from 'react';
import { Container, Icon, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { Webform } from '@uncinc/react-drupal-core';

import { ButtonWrapper } from '../../components';

import './style.scss';

const DesignSystem = () => {
  return (
    <section className="DesignSystem">
      <div className="Paragraph">
        <Container>
          <h2>Spacers</h2>
          <div className="margins">
            <div className="margins__0" />
            <div className="margins__1">2px<span /></div>
            <div className="margins__2">4px<span /></div>
            <div className="margins__3">8px<span /></div>
            <div className="margins__4">12px<span /></div>
            <div className="margins__5">16px<span /></div>
            <div className="margins__6">20px<span /></div>
            <div className="margins__7">24px<span /></div>
            <div className="margins__8">32px<span /></div>
            <div className="margins__9">36px<span /></div>
            <div className="margins__10">48px<span /></div>
            <div className="margins__11">56px<span /></div>
            <div className="margins__12">64px<span /></div>
            <div className="margins__13">72px<span /></div>
            <div className="margins__14">96px<span /></div>
            <div className="margins__15">120px<span /></div>
            <div className="margins__16">144px<span /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div>
            <h1>H1 The quick brown fox jumps over the lazy dog</h1>
            <h2>H2 The quick brown fox jumps over the lazy dog</h2>
            <h3>H3 The quick brown fox jumps over the lazy dog</h3>
            <h4>H4 The quick brown fox jumps over the lazy dog</h4>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div>
            <div className="text--large">
              <p>P text--large   The quick brown fox jumps over the lazy dog</p>
            </div>
            <div className="text--regular">
              <p>P text--regular   The quick brown fox jumps over the lazy dog</p>
            </div>
            <div className="text--small">
              <p>P text--small   The quick brown fox jumps over the lazy dog</p>
            </div>
            <div className="caption">
              <p>caption The quick brown fox jumps over the lazy dog</p>
            </div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div>
            <ul>
              <li>The quick brown fox jumps over the lazy dog and went shopping for another brown fox to jumps over the lazy dog</li>
              <li>The quick brown fox jumps over the lazy dog went shopping for another brown fox to jumps over the lazy dog</li>
              <li>The quick brown fox jumps over the lazy dog went shopping for another brown fox to jumps over the lazy dog </li>
            </ul>
            <p>Some more text</p>

            <ol>
              <li>The quick brown fox jumps over the lazy dog once</li>
              <li>The quick brown fox jumps over the lazy dog twice</li>
              <li>The quick brown fox jumps over the lazy dog thrice</li>
            </ol>
            <p>Some more text</p>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Base colors</h3>
          <div className="Colors">
            <div className="Colors__1" />
            <div className="Colors__2" />
            <div className="Colors__3" />
            <div className="Colors__4" />
            <div className="Colors__5" />
            <div className="Colors__6" />
            <div className="Colors__7" />
          </div>
          <div className="Colors">
            <div className="Colors__8" />
            <div className="Colors__9" />
            <div className="Colors__10" />
            <div className="Colors__11" />
            <div className="Colors__12" />
            <div className="Colors__13" />
            <div className="Colors__14" />
            <div className="Colors__15" />
          </div>
          <div className="Colors">
            <div className="Colors__16" />
            <div className="Colors__17" />
            <div className="Colors__18" />
            <div className="Colors__19" />
            <div className="Colors__20" />
            <div className="Colors__21" />
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container className="Grid">
          <h3>Grid systeem</h3>
        </Container>
        <Container small>
          <h3>Small</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-4"><div className="column" /></div>
            <div className="col-4"><div className="column" /></div>
            <div className="col-4"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container medium>
          <h3>Medium</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-5"><div className="column" /></div>
            <div className="col-7"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Normal</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-5"><div className="column" /></div>
            <div className="col-7"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container large>
          <h3>Large</h3>
          <div className="row">
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
            <div className="col-1"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-3"><div className="column" /></div>
            <div className="col-6"><div className="column" /></div>
            <div className="col-3"><div className="column" /></div>
          </div>
          <div className="row">
            <div className="col-12"><div className="column" /></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Buttons</h3>
          <div className="buttons">
            <ButtonWrapper href="/">Button with link</ButtonWrapper>
            <ButtonWrapper href="https://">Button with external link</ButtonWrapper>
            <ButtonWrapper href="/" bubble={false}>Button without bubble</ButtonWrapper>
            <div className="buttons__inverted">
              <ButtonWrapper href="https://" inverted>Button with external link</ButtonWrapper>
              <ButtonWrapper href="/" inverted bubble={false}>Inverted without bubble</ButtonWrapper>
            </div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h3>Links</h3>
          <div className="links">
            <a className="link--text" href="/">Tekstuele link <Icon name="arrow_forward" flair="outlined" /></a>
            <WysiwygField
              html='<p>The quick brown fox jumps over the <a href="/">inline</a> lazy dog</p>'
            />
          </div>

          <h3>Icons</h3>

          <h3>Form elements</h3>

          <div className="forms">
            <Webform id="design_system" />
          </div>
        </Container>
      </div>
    </section>
  );

};

export default DesignSystem;
